"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageType = exports.pageStatus = exports.companyAppStatus = void 0;
// 页面状态
var companyAppStatus = exports.companyAppStatus = [{
  label: '新增',
  value: 1
}, {
  label: '已下载',
  value: 2
}, {
  label: '已发布',
  value: 3
}, {
  label: '暂停使用',
  value: 4
}];

// 页面类型
var pageType = exports.pageType = [{
  label: '首页',
  value: 1
}, {
  label: '专题页',
  value: 2
}, {
  label: '共享页',
  value: 3
}, {
  label: '权益卡包兑换页',
  value: 4
}, {
  label: '游客首页',
  value: 5
}];
// 页面状态
var pageStatus = exports.pageStatus = [{
  label: '禁用',
  value: 0
}, {
  label: '已发布',
  value: 1
}, {
  label: '装修中',
  value: 2
}];